import { render } from "./IdenticalFormulationCompleteModal.vue?vue&type=template&id=214137eb"
const script = {}

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/parts/IdenticalFormulationCompleteModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "214137eb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('214137eb', __exports__)) {
    console.log('reload')
    api.reload('214137eb', __exports__)
  }
  
  module.hot.accept("./IdenticalFormulationCompleteModal.vue?vue&type=template&id=214137eb", () => {
    console.log('re-render')
    api.rerender('214137eb', render)
  })

}


export default __exports__